import { Navigate, useParams } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import { useSeo } from '@/hooks/useSeo';
import { categoryMeta, getWorksByType, type MediaType } from '@/mocks/catalog';
import CatalogBrowser from '@/pages/category/components/CatalogBrowser';

const validTypes: MediaType[] = ['movie', 'tv', 'show'];

export default function CategoryListPage() {
  const { type } = useParams<{ type: string }>();
  const isValid = type && validTypes.includes(type as MediaType);
  const mediaType = (isValid ? type : 'movie') as MediaType;
  const meta = categoryMeta[mediaType];
  const list = getWorksByType(mediaType);

  useSeo({
    title: `${meta.en} 资源列表 - 91大神影视平台`,
    description: `浏览${meta.name}的全部资源列表，可按类型、地区、年份与热度排序筛选，${meta.desc}。`,
    keywords: `91大神, ${meta.en}, 资源列表, 影视筛选, ${mediaType === 'show' ? '综艺列表' : '高清资源'}`,
    canonicalPath: `/category/${mediaType}/list`,
  });

  if (!isValid) {
    return <Navigate to="/category/movie/list" replace />;
  }

  return (
    <SiteLayout>
      <div className="w-full px-4 py-6 md:px-8 md:py-8">
        <div className="mx-auto w-full max-w-[1400px]">
          <CatalogBrowser type={mediaType} list={list} pageSize={8} headingTitle={`${meta.en} 资源列表`} />
        </div>
      </div>
    </SiteLayout>
  );
}